import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../src/assets/css/line-awesome.min.css";
import "../src/assets/css/style.css";
import "../src/assets/css/responsive.css";
import { LightgalleryProvider } from "react-lightgallery";
import "../src/landing_website/assets/css/landing_style.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MsalProvider instance={msalInstance}>
  <LightgalleryProvider
    lightgallerySettings={
      {
        // settings: https://sachinchoolur.github.io/lightgallery.js/docs/api.html
      }
    }
    galleryClassName="my_custom_classname"
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </LightgalleryProvider>
  </MsalProvider>
);

reportWebVitals();
